export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline": "透明でボーダーレスな寛容さのためのインフラストラクチャー。",
    "common.skipToMainContent": "メインコンテンツへスキップ",
    "common.cancel": "キャンセル",
    "common.edit": "編集",
    "common.delete": "削除",
    "common.creating": "作成中...",
    "common.unknown": "不明",
    "common.notAvailable": "N/A",

    // Navigation
    "nav.browse": "チャリティを検索",
    "nav.opportunities": "ボランティア機会",
    "nav.contributions": "貢献トラッカー",
    "nav.governance": "ガバナンス",
    "nav.dashboard": "Give ダッシュボード",
    "nav.about": "概要",
    "nav.docs": "ドキュメント",
    "nav.legal": "法的情報",
    "nav.launchApp": "アプリを起動",

    // FAQ page (GIV-988)
    "faq.title": "よくある質問",
    "faq.subtitle":
      "寄付、ボランティア、ブロックチェーンの透明性について知っておくべきことをすべてご紹介します。",

    // Settings
    "settings.title": "設定",
    "settings.language": "言語",
    "settings.currency": "通貨",

    // Auth
    "auth.login": "サインイン",
    "auth.register": "アカウント作成",
    "auth.logout": "サインアウト",
    "auth.forgotPassword": "パスワードをお忘れですか？",

    // Dashboard
    "dashboard.title": "Give ダッシュボード",
    "dashboard.subtitle": "寄付とボランティア貢献を追跡します",
    "dashboard.totalDonations": "総寄付額",
    "dashboard.volunteerHours": "ボランティア時間",
    "dashboard.skillsEndorsed": "承認されたスキル",
    "dashboard.contributions": "貢献",
    "dashboard.yourTotalDonated": "あなたの総寄付額",
    "dashboard.yourVolunteerHours": "あなたのボランティア時間",
    "dashboard.yourSkillsEndorsed": "あなたの承認済みスキル",
    "dashboard.impactGrowth": "インパクトの成長",
    "dashboard.charitiesSupported": "支援した団体数",

    // Charity
    "charity.dashboard": "チャリティダッシュボード",
    "charity.subtitle": "寄付とボランティアプログラムを管理します",
    "charity.activeVolunteers": "アクティブなボランティア",
    "charity.transactions": "取引",
    "charity.volunteers": "ボランティア時間",
    "charity.applications": "申請",
    "charity.totalReceived": "受領総額",
    "charity.equityPoolValue": "エクイティプールの価値",
    "charity.availableBalance": "利用可能残高",

    // Contributions
    "contributions.date": "日付",
    "contributions.type": "タイプ",
    "contributions.organization": "団体",
    "contributions.details": "詳細",
    "contributions.status": "ステータス",
    "contributions.verification": "検証",
    "contributions.export": "CSV エクスポート",

    // Volunteer
    "volunteer.opportunities": "ボランティア機会",
    "volunteer.searchOpportunities": "機会を検索...",
    "volunteer.selectSkill": "スキルを選択",
    "volunteer.selectType": "タイプを選択",
    "volunteer.selectLanguage": "言語を選択",
    "volunteer.allSkills": "すべてのスキル",
    "volunteer.allTypes": "すべてのタイプ",
    "volunteer.allLanguages": "すべての言語",
    "volunteer.applyNow": "今すぐ応募",
    "volunteer.noOpportunitiesFound":
      "条件に一致する機会が見つかりませんでした。",
    "volunteer.verify": "時間を検証",
    "volunteer.verifying": "検証中...",
    "volunteer.reject": "却下",
    "volunteer.accept": "承認",
    "volunteer.processing": "処理中...",
    "volunteer.hours": "時間（活動日：",
    "volunteer.description": "説明",
    "volunteer.appliedFor": "応募先",
    "volunteer.verificationComplete": "検証完了",
    "volunteer.hoursVerified":
      "ボランティア時間が検証され、ブロックチェーンに記録されました。",
    "volunteer.verificationHash": "検証ハッシュ",
    "volunteer.applicationAccepted": "申請承認済み",
    "volunteer.applicationRecorded":
      "ボランティア申請が承認され、ブロックチェーンに記録されました。",
    "volunteer.acceptanceHash": "承認ハッシュ",
    "volunteer.pendingHours": "保留中のボランティア時間",
    "volunteer.noPendingHours": "検証待ちのボランティア時間はありません。",
    "volunteer.pendingApplications": "保留中の申請",
    "volunteer.noPendingApplications": "レビュー待ちの申請はありません。",
    "volunteer.createOpportunity": "ボランティア機会を作成",
    "volunteer.createNew": "新規作成",
    "volunteer.noOpportunitiesYet":
      "まだ機会が作成されていません。「新規作成」をクリックして始めましょう。",
    "volunteer.opportunityTitle": "機会のタイトル",
    "volunteer.skills": "スキル（カンマ区切り）",
    "volunteer.commitment": "コミットメント",
    "volunteer.location": "場所",
    "volunteer.type": "タイプ",
    "volunteer.workLanguage": "作業言語",
    "volunteer.status": "ステータス",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "単発",
    "volunteer.commitment.shortTerm": "短期",
    "volunteer.commitment.longTerm": "長期",

    // Volunteer types
    "volunteer.type.remote": "リモート",
    "volunteer.type.onsite": "現地",
    "volunteer.type.hybrid": "ハイブリッド",
    "volunteer.type.onSite": "現地",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "勤務形態フィルター",
    "volunteer.searchLocation": "市区町村または地域...",
    "volunteer.searchLocationAria": "場所を検索",
    "volunteer.filter.skill": "スキル: {{value}}",
    "volunteer.filter.type": "タイプ: {{value}}",
    "volunteer.filter.language": "言語: {{value}}",
    "volunteer.filter.location": "場所: {{value}}",
    "volunteer.loadingOpportunities": "募集を読み込み中...",
    "volunteer.loadOpportunitiesError": "ボランティア募集を読み込めませんでした。後でもう一度お試しください。",
    "volunteer.viewDetails": "詳細を見る",
    "volunteer.backToOpportunities": "募集一覧に戻る",
    "volunteer.detail.about": "この募集について",
    "volunteer.detail.skills": "必要なスキル",
    "volunteer.detail.commitment": "時間の目安",
    "volunteer.detail.location": "場所",
    "volunteer.detail.language": "言語",
    "volunteer.detail.hostedBy": "主催",
    "volunteer.detail.ongoing": "継続中",
    "volunteer.detail.applicationsClosed": "応募受付終了",
    "volunteer.detail.notFoundTitle": "募集が見つかりません",
    "volunteer.detail.notFoundMessage": "この募集は締め切られたか、削除された可能性があります。",
    "volunteer.field.requirements": "応募要件",
    "volunteer.field.benefits": "特典",
    "volunteer.field.schedule": "スケジュール",
    "volunteer.field.schedulePlaceholder": "例: 火曜 18-20時、週末は柔軟に",
    "volunteer.field.startDate": "開始日",
    "volunteer.field.endDate": "終了日",
    "volunteer.field.endDateHelp": "継続中の場合は空欄",
    "volunteer.field.applicationDeadline": "応募締切",
    "volunteer.field.volunteersNeeded": "募集人数",
    "volunteer.field.minimumAge": "最低年齢",
    "volunteer.field.backgroundCheckRequired": "身元調査が必要",
    "volunteer.field.trainingProvided": "研修あり",
    "volunteer.field.onePerLine": "1行に1項目",
    "volunteer.validation.volunteersNeeded": "1以上の数値を入力してください",
    "volunteer.validation.minimumAge": "0〜120の年齢を入力してください",
    "volunteer.validation.endDate": "終了日は開始日以降にしてください",
    "volunteer.signInToApply":
      "ボランティア機会に応募するにはサインインしてください",
    "volunteer.applicationSuccess": "申請が正常に送信されました！",
    "volunteer.removeFilter": "{{filter}}フィルターを削除",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "タイトルは必須です",
    "volunteer.validation.descriptionRequired": "説明は必須です",
    "volunteer.validation.skillsRequired": "少なくとも1つのスキルが必要です",
    "volunteer.validation.locationRequired": "場所は必須です",
    "volunteer.profileNotFound": "ユーザープロフィールが見つかりません",
    "volunteer.correctErrors": "バリデーションエラーを修正してください",
    "volunteer.createFailed": "機会の作成に失敗しました",
    "volunteer.descriptionPlaceholder":
      "ボランティア機会の詳細を記述してください...",
    "volunteer.skillsPlaceholder": "例：Web開発、プロジェクト管理、翻訳",
    "volunteer.locationPlaceholder": "例：リモート、東京、大阪",
    "volunteer.headerImage": "ヘッダー画像",
    "volunteer.headerImageHelp":
      "機会リスティングの上部に表示する画像をアップロードしてください",
    "volunteer.limitReached": "機会の上限に達しました",
    "volunteer.limitReachedMessage":
      "アクティブなボランティア機会の上限{{max}}件に達しました。新しい機会を作成する前に、既存の機会を終了または完了してください。",
    "volunteer.opportunityCount":
      "{{count}} / {{max}} 件のアクティブな機会があります。",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "時間の検証",
    "volunteer.hoursVerificationDescription":
      "ボランティア時間の提出をレビューおよび検証します",
    "volunteer.formalHours": "記録済み時間",
    "volunteer.selfReported": "自己申告",
    "volunteer.loggedHours": "記録済みボランティア時間",
    "volunteer.loggedHoursDescription":
      "ボランティアが機会を通じて記録した時間",
    "volunteer.allCaughtUp": "すべて対応済みです！",
    "volunteer.noPendingLoggedHours": "検証待ちの記録済み時間はありません。",
    "volunteer.selfReportedHours": "自己申告時間",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "まだ機会がありません",
    "volunteer.activeCount": "{{count}} / {{max}} 件のアクティブな機会",
    "volunteer.moreSkills": "+{{count}} 件",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "保留中の申請はありません",
    "volunteer.unknownOpportunity": "不明な機会",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "ボランティア貢献を検証",
    "volunteer.hashPlaceholder": "検証ハッシュを入力",
    "volunteer.searching": "検索中...",
    "volunteer.verifyHash": "ハッシュを検証",
    "volunteer.verificationNotFound": "検証が見つかりません",
    "volunteer.verificationNotFoundMessage":
      "入力されたハッシュは記録に見つかりませんでした。ハッシュを確認して再度お試しください。",
    "volunteer.unknownOrganization": "不明な団体",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification": "ボランティア貢献の検証",
    "volunteer.volunteerLabel": "ボランティア",
    "volunteer.opportunityLabel": "機会",
    "volunteer.organizationLabel": "団体",
    "volunteer.acceptedOn": "承認日",
    "volunteer.verifiedOn": "検証日",
    "volunteer.verificationHashes": "検証ハッシュ",
    "volunteer.blockchainReference": "ブロックチェーン参照",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "貢献を検証中\u2026",
    "volunteer.noHashProvided": "検証ハッシュが提供されていません。",
    "volunteer.verificationSuccessful": "検証成功",
    "volunteer.contributionVerifiedBlockchain":
      "このボランティア貢献は検証され、ブロックチェーンに記録されています。",
    "volunteer.verificationFailed": "検証失敗",
    "volunteer.hashNotFound":
      "検証ハッシュ {{hash}} が見つからないか、無効です。",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "ボランティア時間",
    "volunteer.aboutSelfReported": "自己申告時間について",
    "volunteer.selfReportedInfo":
      "認証済み団体によって検証された時間のみがグローバルインパクトランキングの対象となります。プラットフォーム外の団体での活動時間は記録できますが、検証を受けるまで「未検証」と表示されます。",
    "volunteer.logHoursButton": "時間を記録",
    "volunteer.logVolunteerHours": "ボランティア時間を記録",
    "volunteer.editRecord": "記録を編集",
    "volunteer.recordDetails": "記録の詳細",
    "volunteer.backToList": "一覧に戻る",
    "volunteer.deleteRecord": "記録を削除しますか？",
    "volunteer.deleteConfirmation":
      "このボランティア時間の記録を削除してもよろしいですか？この操作は元に戻せません。",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "活動タイプ",
    "volunteer.organization": "団体",
    "volunteer.searchRegistry": "レジストリを検索",
    "volunteer.searchRegistryPlaceholder":
      "名前または納税者番号でチャリティ登録簿を検索…",
    "volunteer.registryTaxId": "納税者番号 {{value}}",
    "volunteer.notListed": "一覧にない",
    "volunteer.organizationName": "団体名",
    "volunteer.enterOrgName": "団体名を入力",
    "volunteer.contactEmail": "連絡先メールアドレス",
    "volunteer.contactEmailOptional": "（任意）",
    "volunteer.onboardHelp":
      "この団体のオンボーディングのためにご連絡する場合があります",
    "volunteer.submittedForValidation": "この記録は検証のために提出されます",
    "volunteer.submittedForValidationTo":
      "この記録は {{org}} への検証のために提出されます",
    "volunteer.validationExpired": "この日付の検証期間は終了しています",
    "volunteer.savedAsUnvalidated": "この記録は未検証として保存されます",
    "volunteer.describeActivities": "実施した活動内容を記述してください...",
    "volunteer.moreCharsNeeded": "あと{{count}}文字必要です",
    "volunteer.updating": "更新中...",
    "volunteer.logging": "記録中...",
    "volunteer.updateHours": "時間を更新",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "ステータス",
    "volunteer.activityTypeFilter": "活動タイプ",
    "volunteer.filterFrom": "開始日",
    "volunteer.filterTo": "終了日",
    "volunteer.clearFilters": "フィルターをクリア",
    "volunteer.allStatuses": "すべて",
    "volunteer.allActivityTypes": "すべてのタイプ",
    "volunteer.noMatchingRecords": "一致する記録がありません",
    "volunteer.noHoursLogged": "まだボランティア時間が記録されていません",
    "volunteer.adjustFilters":
      "フィルターを調整して記録を検索してみてください。",
    "volunteer.startLogging": "最初のボランティア時間を記録しましょう。",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "検証済み時間",
    "volunteer.pendingValidation": "検証待ち",
    "volunteer.unvalidatedHours": "未検証時間",
    "volunteer.rejectedLabel": "却下済み",
    "volunteer.hoursUnit": "時間",
    "volunteer.recordSingular": "件",
    "volunteer.recordPlural": "件",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle": "ボランティア機会への応募",
    "volunteer.applicationSubtitle":
      "検証済みの貢献を通じて持続可能なインパクトを創出しましょう",
    "volunteer.progress.info": "情報",
    "volunteer.progress.skills": "スキル",
    "volunteer.progress.consent": "同意",
    "volunteer.fieldValid": "問題ありません",
    "volunteer.draftSaved": "下書きを保存しました",
    "volunteer.personalInfo": "個人情報",
    "volunteer.firstName": "名",
    "volunteer.lastName": "姓",
    "volunteer.emailAddress": "メールアドレス",
    "volunteer.phoneNumber": "電話番号",
    "volunteer.locationCity": "所在地/市区町村",
    "volunteer.locationCityPlaceholder": "例：東京都渋谷区",
    "volunteer.timeZone": "タイムゾーン",
    "volunteer.selectTimeZone": "タイムゾーンを選択",
    "volunteer.ageRange": "年齢層",
    "volunteer.selectAgeRange": "年齢層を選択",
    "volunteer.skillsAndInterests": "スキルと関心分野",
    "volunteer.skillsLabel": "スキルと関心のある分野",
    "volunteer.skillPlaceholderFull":
      "スキルを入力してください（例：Pythonプログラミング、プレゼンテーション、助成金申請書作成）",
    "volunteer.skillPlaceholderShort":
      "スキルを入力してEnterキーを押してください...",
    "volunteer.commitmentLevel": "コミットメントレベル",
    "volunteer.commitmentOneTimeDesc": "単発のプロジェクトまたは短期間のタスク",
    "volunteer.commitmentShortTermDesc": "数週間から数ヶ月程度",
    "volunteer.commitmentLongTermDesc": "数ヶ月以上の継続的なコミットメント",
    "volunteer.experienceLabel": "関連する経験についてお聞かせください",
    "volunteer.experiencePlaceholder":
      "あなたの経歴、スキル、Give Protocolでボランティアをしたい動機を記述してください...",
    "volunteer.consentTitle": "同意と承諾",
    "volunteer.consentHeader": "ボランティア申請の同意",
    "volunteer.submitting": "送信中...",
    "volunteer.submitApplication": "ボランティア申請を送信",
    "volunteer.disclaimerText":
      "この申請を送信することにより、Give Protocolのプライバシーポリシーとボランティアガイドラインを読み、理解したことを認めます。お客様のデータは、適用されるデータ保護規制に従って処理されます。",
    "volunteer.validation.firstNameInvalid": "有効な名前を入力してください",
    "volunteer.validation.lastNameInvalid": "有効な姓を入力してください",
    "volunteer.validation.emailInvalid":
      "有効なメールアドレスを入力してください",
    "volunteer.validation.phoneInvalid": "有効な電話番号を入力してください",
    "volunteer.validation.experienceRequired": "関連する経験を記述してください",
    "volunteer.validation.addSkill": "少なくとも1つのスキルを追加してください",
    "volunteer.validation.ageRangeRequired": "年齢層を選択してください",
    "volunteer.validation.consentRequired":
      "すべての必須同意項目に同意する必要があります",
    "volunteer.signInToSubmit": "申請を送信するにはサインインしてください",
    "volunteer.submitFailed":
      "申請の送信に失敗しました。もう一度お試しください。",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "応募先：{{title}}",
    "volunteer.fullName": "氏名 *",
    "volunteer.phoneRequired": "電話番号 *",
    "volunteer.emailRequired": "メールアドレス *",
    "volunteer.dateOfBirth": "生年月日",
    "volunteer.availabilityTitle": "参加可能日時",
    "volunteer.preferredDays": "希望曜日",
    "volunteer.preferredTimes": "希望時間帯",
    "volunteer.commitmentLevelLabel": "コミットメントレベル",
    "volunteer.skillsAndExperience": "スキルと経験",
    "volunteer.relevantExperience": "関連する経験 *",
    "volunteer.certifications": "資格（カンマ区切り）",
    "volunteer.interestsAndPreferences": "関心と希望",
    "volunteer.areasOfInterest": "関心のある分野（カンマ区切り）",
    "volunteer.referencesTitle": "推薦者",
    "volunteer.referenceName": "推薦者{{index}}の氏名",
    "volunteer.referenceContact": "推薦者{{index}}の連絡先",
    "volunteer.workSamplesTitle": "作品サンプル",
    "volunteer.workSamplesLabel": "作品サンプルへのリンク（カンマ区切り）",
    "volunteer.submitApplicationShort": "申請を送信",
    "volunteer.validation.nameInvalid":
      "有効な名前を入力してください（2〜100文字）",
    "volunteer.validation.provideExperience":
      "経験に関する情報を入力してください",
    "volunteer.validation.selectDay": "少なくとも1つの曜日を選択してください",
    "volunteer.validation.selectTime":
      "少なくとも1つの時間帯を選択してください",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "以下の事項を理解しています：",
    "volunteer.processingAckTitle": "処理の確認",
    "volunteer.processingAckDesc": "続行する前に、以下を確認してください：",
    "volunteer.essentialProcessingTitle": "申請処理（確認が必要）：",
    "volunteer.acknowledgmentTitle": "確認事項",
    "volunteer.ageConfirmationTitle": "年齢確認：",
    "volunteer.privacyNoticeTitle": "プライバシー通知：",
    "volunteer.doNotAccept": "同意しない",
    "volunteer.acceptAndContinue": "同意して続行",
    "volunteer.validation.essentialRequired":
      "続行するには申請処理の確認を承認する必要があります",
    "volunteer.validation.agePrivacyRequired":
      "年齢の確認とプライバシー通知の閲覧を確認する必要があります",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive": "16歳以上であることを確認します。",
    "ageGate.negative":
      "Give Protocolは16歳以上のユーザーがご利用いただけます。16歳未満の場合、現時点ではリクエストを処理することができません。",

    // Languages
    "language.english": "英語",
    "language.spanish": "スペイン語",
    "language.german": "ドイツ語",
    "language.french": "フランス語",
    "language.japanese": "日本語",
    "language.chinese_simplified": "中国語（簡体字）",
    "language.chinese_traditional": "中国語（繁体字）",
    "language.thai": "タイ語",
    "language.vietnamese": "ベトナム語",
    "language.korean": "韓国語",
    "language.arabic": "アラビア語",
    "language.hindi": "ヒンディー語",
    "language.multiple": "複数の言語",

    // Contribution types
    "contribution.type.donation": "寄付",
    "contribution.type.volunteerapplication": "ボランティア申請",
    "contribution.type.volunteerhours": "ボランティア時間",
    "contribution.type.volunteeracceptance": "ボランティア承認",
    "contribution.type.volunteerverification": "ボランティア検証",

    // Donor/Volunteer
    "donor.volunteer": "寄付者/ボランティア",
    "donor.anonymous": "匿名",
    "volunteer.unknown": "不明なボランティア",

    // Statuses
    "status.completed": "完了",
    "status.pending": "保留中",
    "status.failed": "失敗",

    // Blockchain
    "blockchain.block": "ブロック",

    // Filter
    "filter.allYears": "すべての年",
    "filter.allTypes": "すべてのタイプ",
    "filter.donations": "寄付",
    "filter.volunteerApplications": "ボランティア申請",
    "filter.volunteerHours": "ボランティア時間",
    "filter.fiatDonations": "法定通貨による寄付",

    // Export
    "export.title": "貢献データのエクスポート",
    "export.filename": "ファイル名",
    "export.dateRange": "日付範囲",
    "export.includePersonal": "ウォレットアドレスを含める",
    "export.willInclude": "エクスポートに含まれるもの：",
    "export.walletAddresses": "ウォレットアドレス（送信者と受信者）",
    "export.volunteerDetails": "ボランティア貢献の詳細（該当する場合）",
    "export.verificationHashes": "検証ハッシュ（該当する場合）",
    "export.cancel": "キャンセル",
    "export.download": "CSV エクスポート",

    // Skills
    "skills.endorsements": "スキルと推薦",

    // Home
    "home.subtitle": "最も必要とされている活動にリソースをつなぎます",
    "home.startDonating": "寄付を始める",

    // Modal - shared
    "modal.close": "モーダルを閉じる",
    "modal.closeAriaLabel": "閉じる",

    // Modal - wallet connection
    "modal.wallet.title": "ウォレットを接続",
    "modal.wallet.description":
      "ウォレットを接続して Give Protocol のすべての機能を利用しましょう",
    "modal.wallet.benefit1": "ブロックチェーン上で寄付を透明に追跡できます",
    "modal.wallet.benefit2":
      "貢献に対する報酬として GIVE トークンを受け取れます",
    "modal.wallet.benefit3": "プロトコルのガバナンス決定に参加できます",
    "modal.wallet.connecting": "接続中...",
    "modal.wallet.clickToConnect": "クリックして接続",
    "modal.wallet.noExtension": "ウォレット拡張機能が検出されませんでした。",
    "modal.wallet.installMetaMask": "MetaMask をインストールして始めましょう",
    "modal.wallet.skip": "今はスキップ",
    "modal.wallet.footerNote":
      "ナビゲーションバーからいつでもウォレットを接続できます",
    "modal.wallet.failedConnect": "ウォレットの接続に失敗しました",

    // Modal - wallet link
    "modal.walletLink.title": "ウォレットをリンク",
    "modal.walletLink.description":
      "オンチェーン寄付、トークン報酬、ガバナンスのためにウォレットをアカウントにリンクします",
    "modal.walletLink.benefit1":
      "検証済みチャリティにオンチェーンで直接暗号通貨を寄付できます",
    "modal.walletLink.benefit2Pre": "貢献に対する",
    "modal.walletLink.benefit2Post": "クレデンシャルを構築できます",
    "modal.walletLink.benefit3":
      "メールまたはウォレットでサインイン \u2014 同じアカウントです",
    "modal.walletLink.buttonLinking": "リンク中\u2026",
    "modal.walletLink.buttonLink": "ウォレットをリンク",
    "modal.walletLink.buttonConnectFirst": "まずウォレットを接続",
    "modal.walletLink.footerNote": "設定からいつでもウォレットをリンクできます",
    "modal.walletLink.failedLink": "ウォレットのリンクに失敗しました",

    // Modal - chain selection
    "modal.chain.title": "Give Protocol へようこそ",
    "modal.chain.subtitle": "ご希望のネットワークを選択して始めましょう",
    "modal.chain.footerNote":
      "メニューからいつでもネットワークを切り替えられます",
    "modal.chain.connecting": "接続中...",
    "modal.chain.continue": "続行",
    "modal.chain.failedSelect": "ネットワークの選択に失敗しました",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "ネットワークを選択",
    "modal.network.nextStep": "次のステップ：ウォレットを接続",
    "modal.network.learnMore": "ネットワーク選択について詳しく",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "ウォレットを接続",
    "modal.connect.backAria": "ネットワーク選択に戻る",
    "modal.connect.noWallets":
      "{{chainType}}チェーンで利用可能なウォレットがありません。",
    "modal.connect.tryDifferentChain":
      "別のチェーンタイプを選択してみてください。",
    "modal.connect.viewOtherWallets": "他の対応ウォレットを表示",
    "modal.connect.termsAgreement": "接続することにより、当社の",
    "modal.connect.termsLink": "利用規約",
    "modal.connect.termsPrivacyConnector": "および",
    "modal.connect.privacyLink": "プライバシーポリシー",
    "modal.connect.chainTypeAria": "チェーンタイプ",
    "modal.connect.failedConnect": "接続に失敗しました",

    // Modal - donation
    "modal.donation.successTitle": "ありがとうございます！",
    "modal.donation.donationProcessedOneTime":
      "{{charityName}}への{{amount}}の寄付が処理されました。",
    "modal.donation.donationProcessedRecurring":
      "{{charityName}}への月額{{amount}}の寄付が処理されました。",
    "modal.donation.recurringNote": "キャンセルするまで毎月課金されます。",
    "modal.donation.receiptNote": "領収書がメールで送信されました。",
    "modal.donation.done": "完了",
    "modal.donation.errorTitle": "問題が発生しました",
    "modal.donation.errorDefault":
      "予期しないエラーが発生しました。もう一度お試しください。",
    "modal.donation.tryAgain": "再試行",
    "modal.donation.close": "閉じる",
    "modal.donation.amountLabel": "寄付金額",
    "modal.donation.perMonth": "/ 月",
    "modal.donation.monthly": "月額",
    "modal.donation.oneTime": "一回限り",
    "modal.donation.loadingPaymentForm": "支払いフォームを読み込み中...",
    "modal.donation.supportMonthly": "{{charityName}}を月額で支援",
    "modal.donation.donateToCharity": "{{charityName}}に寄付",

    // Modal - scheduled donation
    "modal.scheduledDonation.title": "{{charityName}}への月額寄付を設定",

    // Modal - withdrawal
    "modal.withdrawal.title": "出金リクエスト",

    // Modal - validation response
    "modal.validation.rejectTitle": "検証リクエストを却下",
    "modal.validation.reviewTitle": "検証リクエストをレビュー",
    "modal.validation.volunteer": "ボランティア",
    "modal.validation.activityDetails": "活動の詳細",
    "modal.validation.date": "日付",
    "modal.validation.hour": "時間",
    "modal.validation.hours": "時間",
    "modal.validation.activityType": "活動タイプ",
    "modal.validation.location": "場所",
    "modal.validation.description": "説明",
    "modal.validation.submitted": "提出日：",
    "modal.validation.daysRemaining": "（検証まで残り{{count}}日）",
    "modal.validation.appealNote": "これは以前却下されたリクエストの再申請です",
    "modal.validation.rejectPrompt":
      "この検証リクエストを却下する理由を選択してください。ボランティアに通知されます。",
    "modal.validation.reject": "却下",
    "modal.validation.approve": "承認",
    "modal.validation.processing": "処理中...",
    "modal.validation.back": "戻る",
    "modal.validation.confirmRejection": "却下を確認",
    "modal.validation.selectReasonError": "却下理由を選択してください",

    // Toast
    "toast.dismiss": "通知を閉じる",

    // Error boundary
    "error.somethingWrong": "問題が発生しました",
    "error.unexpectedError": "予期しないエラーが発生しました",
    "error.tryAgain": "再試行",
    "error.tooManyAttempts": "試行回数が多すぎます",
    "error.goHome": "ホームページへ",
    "error.details": "エラーの詳細",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "却下理由",
    "validation.rejection.reasonPlaceholder": "理由を選択...",
    "validation.rejection.notesLabel": "追加メモ",
    "validation.rejection.optional": "（任意）",
    "validation.rejection.notesPlaceholder":
      "却下の追加コンテキストを記入してください...",

    // Validation - batch actions
    "validation.batch.deselectAll": "すべて選択解除",
    "validation.batch.selectAll": "すべて選択",
    "validation.batch.selected": "{{total}}件中{{selected}}件を選択",
    "validation.batch.clear": "クリア",
    "validation.batch.reject": "却下 ({{count}})",
    "validation.batch.approve": "承認 ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "管理者ダッシュボード",
    "dashboard.adminNote":
      "プラットフォームの管理には管理パネルをご利用ください。",
    "dashboard.adminButton": "管理パネルへ",
    "dashboard.logVolunteerHours": "ボランティア時間を記録",
    "dashboard.hideVolunteerHours": "ボランティア時間を非表示",
    "dashboard.viewMonthlyDonations": "月額寄付を表示",
    "dashboard.hideMonthlyDonations": "月額寄付を非表示",
    "dashboard.walletSettings": "ウォレット設定",
    "dashboard.overview": "概要",
    "dashboard.lastUpdated": "最終更新",
    "dashboard.refreshData": "データを更新",
    "dashboard.searchPlaceholder": "プロジェクト、ボランティアを検索 (Cmd+K)",
    "dashboard.search": "検索",

    // Settings - account section (GIV-254)
    "settings.manageDescription": "アカウントと設定を管理します",
    "settings.account": "アカウント",
    "settings.email": "メールアドレス",
    "settings.displayName": "表示名",
    "settings.authMethod": "認証方法",
    "settings.role": "ロール",

    // Common additional (GIV-254)
    "common.refresh": "更新",
    "common.all": "すべて",
    "common.loading": "読み込み中...",
    "common.close": "閉じる",
    "common.back": "戻る",

    // Cause (GIV-254)
    "cause.createCause": "活動を作成",

    // Contribution Tracker (GIV-254)
    "tracker.title": "グローバルインパクトランキング",
    "tracker.subtitle":
      "コミュニティの集合的なインパクトを追跡し、称えましょう",
    "tracker.searchPlaceholder": "貢献者を検索...",
    "tracker.exportCSV": "CSV エクスポート",
    "tracker.exportPDF": "PDF エクスポート",
    "tracker.hideContributions": "ランキングから自分の貢献を非表示にする",
    "tracker.yourAlias": "あなたのエイリアス：",
    "tracker.changeAlias": "変更",
    "tracker.setWalletAlias": "ウォレットエイリアスを設定",
    "tracker.aliasTitle": "ウォレットエイリアスを設定",
    "tracker.aliasDescription":
      "エイリアスは貢献トラッカーでウォレットアドレスの代わりに表示されます。",
    "tracker.aliasLabel": "エイリアス",
    "tracker.aliasPlaceholder": "ご希望のエイリアスを入力",
    "tracker.saveAlias": "エイリアスを保存",
    "tracker.donationRankings": "寄付ランキング",
    "tracker.volunteerRankings": "ボランティアランキング",
    "tracker.exportComplete": "エクスポート完了",
    "tracker.exportDonationCSV":
      "寄付ランキングをCSVとしてエクスポートしました",
    "tracker.exportVolunteerCSV":
      "ボランティアランキングをCSVとしてエクスポートしました",
    "tracker.exportPDFSuccess": "ランキングをPDFとしてエクスポートしました",
    "tracker.exportFailed": "エクスポート失敗",
    "tracker.exportNoData": "エクスポートするデータがありません",
    "tracker.exportError": "データのエクスポート中にエラーが発生しました",
    "tracker.walletNotConnected": "ウォレットが接続されていません",
    "tracker.connectWalletForAlias":
      "エイリアスを設定するにはウォレットを接続してください",
    "tracker.invalidAlias": "無効なエイリアス",
    "tracker.enterValidAlias": "有効なエイリアスを入力してください",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "{{type}}を削除しますか？",
    "charity.portal.deleteDescription":
      "この操作は元に戻せません。{{type}}は完全に削除されます。",
    "charity.portal.walletNotConfigured":
      "受信ウォレットが設定されていません。",
    "charity.portal.walletDonationNote":
      "オンチェーン寄付を受け取るにはウォレットを接続してください。",
    "charity.portal.setupWallet": "ウォレットを設定",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "オンボーディングチェックリスト",
    "charity.onboarding.title": "はじめに",
    "charity.onboarding.progress":
      "{{total}}ステップ中{{completed}}ステップ完了",
    "charity.onboarding.optional": "任意",
    "charity.onboarding.allComplete":
      "すべてのステップが完了しました。このチェックリストは閉じて構いません。",
    "charity.onboarding.expand": "チェックリストを展開",
    "charity.onboarding.collapse": "チェックリストを折りたたむ",
    "charity.onboarding.dismiss": "オンボーディングチェックリストを閉じる",
    "charity.onboarding.check": "{{label}}にチェックを付ける",
    "charity.onboarding.uncheck": "{{label}}のチェックを外す",
    "charity.onboarding.stepDone": "{{label}}（完了）",
    "charity.onboarding.stepAuto": "{{label}}（自動的に完了します）",
    "charity.onboarding.goToOrganization": "組織ページへ",
    "charity.onboarding.setupWallet": "ウォレットを設定",
    "charity.onboarding.item.completeProfile.label":
      "組織プロフィールを完成させる",
    "charity.onboarding.item.completeProfile.description":
      "組織名、説明、住所、連絡先情報を追加してください。",
    "charity.onboarding.item.uploadLogo.label":
      "ロゴまたはバナー画像をアップロード",
    "charity.onboarding.item.uploadLogo.description":
      "寄付者が団体を見分けやすいよう、ロゴまたはバナーを追加してください。",
    "charity.onboarding.item.connectWallet.label": "受取用ウォレットを設定",
    "charity.onboarding.item.connectWallet.description":
      "寄付を受け取るために、マルチシグSafe、機関カストディ、または単独署名ウォレットを選択してください。メッセージに署名して管理権限を証明します。",
    "charity.onboarding.item.bankDetails.label":
      "法定通貨への換金用の銀行情報を設定",
    "charity.onboarding.item.bankDetails.description":
      "カード寄付を受け付ける場合は、銀行情報を設定してください。",
    "charity.onboarding.item.acceptTerms.label": "利用規約を確認して同意",
    "charity.onboarding.item.acceptTerms.description":
      "Give Protocolの慈善団体向け利用規約を読み、内容に同意してください。",
    "charity.verification.pendingTitle": "申請を審査中",
    "charity.verification.pendingBody":
      "チームが貴団体の申請を審査しています。通常、3〜5営業日かかります。結果が出次第、メールでお知らせします。",
    "charity.verification.rejectedTitle": "申請は承認されませんでした",
    "charity.verification.reason": "理由：{{notes}}",
    "charity.verification.rejectedDefault":
      "今回は申請が承認されませんでした。",
    "charity.verification.contactSupport": "サポートに問い合わせる",
    "charity.verification.suspendedTitle": "アカウントが停止されています",
    "charity.verification.suspendedDefault":
      "貴団体のアカウントは停止されています。",
    "charity.verification.appealSuspension": "停止に異議を申し立てる",
    "charity.verification.verifiedTitle": "慈善団体の認証済み",
    "charity.verification.verifiedBody":
      "貴団体は認証されました。寄付者が活動を支援できるようになりました。",
    "charity.portal.receivingWallet": "受取用ウォレット：{{address}}",
    "charity.portal.loadError":
      "慈善団体のデータを読み込めませんでした。もう一度お試しください。",

    // Timestamps (GIV-254)
    "timestamp.justNow": "たった今",
    "timestamp.oneMinuteAgo": "1分前",
    "timestamp.minutesAgo": "{{count}}分前",

    // Common additions (GIV-256)
    "common.previous": "前へ",
    "common.next": "次へ",
    "common.pageOfTotal": "{{total}}ページ中{{page}}ページ目",
    "common.retry": "再試行",
    "common.processing": "処理中...",
    "common.saving": "保存中...",
    "common.donate": "寄付する",
    "common.active": "アクティブ",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "寄付タイプ",
    "portfolio.devNative": "DEV（ネイティブ）",
    "portfolio.testToken": "TEST トークン",
    "portfolio.donationAmount": "寄付金額：",
    "portfolio.platformFee": "プラットフォーム手数料 ({{percentage}}%)：",
    "portfolio.toCharities": "チャリティへ：",
    "portfolio.eachCharityReceives": "各チャリティの受取額：",
    "portfolio.donateToFund": "{{name}}に寄付",
    "portfolio.equalDistribution": "均等配分",
    "portfolio.equalDistributionNote":
      "寄付は{{count}}の認証済みチャリティに均等に配分されます。",
    "portfolio.eachCharityPercentage":
      "各チャリティは寄付の{{percentage}}%を受け取ります",
    "portfolio.verifiedCharities": "{{count}}の認証済みチャリティ",
    "portfolio.donateToFundButton": "ファンドに寄付",
    "portfolio.noFundsAvailable":
      "利用可能なポートフォリオファンドがありません",
    "portfolio.checkBackLater": "新しいファンディング機会をお待ちください",
    "portfolio.amountLabel": "金額 ({{currency}})",
    "portfolio.invalidAmount": "有効な金額を入力してください",
    "portfolio.donationSuccess": "寄付が成功しました！",
    "portfolio.donationFailed": "寄付に失敗しました。もう一度お試しください。",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "寄付",
    "admin.activity.registration": "登録",
    "admin.activity.verification": "検証",
    "admin.activity.volunteerHours": "ボランティア時間",
    "admin.activity.default": "アクティビティ",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "管理者ダッシュボード",
    "admin.dashboard.alerts": "アラート",
    "admin.dashboard.alertsPending": "{{count}}件保留中",
    "admin.dashboard.alertsView": "表示",
    "admin.dashboard.recentActivity": "最近のアクティビティ",
    "admin.dashboard.noRecentActivity": "最近のアクティビティはありません。",
    "admin.dashboard.quickActions": "クイックアクション",
    "admin.dashboard.errorTitle": "ダッシュボードの読み込みエラー",
    "admin.stats.last7d": "過去7日間",
    "admin.stats.last30d": "過去30日間",
    "admin.stats.totalDonors": "総寄付者数",
    "admin.stats.newRegistrations": "新規登録",
    "admin.stats.charities": "チャリティ",
    "admin.stats.pendingVerification": "検証待ち",
    "admin.stats.verifiedCharities": "認証済みチャリティ",
    "admin.stats.activeVolunteers": "アクティブなボランティア",
    "admin.stats.totalDonationVolume": "総寄付額",
    "admin.stats.cryptoVolume": "暗号通貨ボリューム",
    "admin.stats.fiatVolume": "法定通貨ボリューム",
    "admin.stats.donations": "寄付",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "レポートを表示",
    "admin.actions.viewReportsDesc": "詳細な分析を作成",
    "admin.actions.manageCharities": "チャリティを管理",
    "admin.actions.manageCharitiesDesc": "団体のレビューと承認",
    "admin.actions.systemSettings": "システム設定",
    "admin.actions.systemSettingsDesc": "プラットフォームパラメータを設定",
    "admin.actions.manageImpactMetrics": "インパクト指標を管理",
    "admin.actions.manageImpactMetricsDesc": "インパクト計算データを設定",
    "admin.actions.donationMonitoring": "寄付モニタリング",
    "admin.actions.donationMonitoringDesc":
      "寄付の監視、フラグ付け、レポート作成",
    "admin.actions.contentModeration": "コンテンツモデレーション",
    "admin.actions.contentModerationDesc":
      "機会と活動の非表示、フラグ付け、レビュー",
    "admin.actions.portfolioFunds": "ポートフォリオファンド",
    "admin.actions.portfolioFundsDesc":
      "キュレーション済み寄付ポートフォリオの作成と管理",
    "admin.actions.charityRequests": "チャリティリクエスト",
    "admin.actions.charityRequestsDesc":
      "未登録チャリティへの寄付者リクエストをレビュー",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "ポートフォリオファンド",
    "admin.portfolio.subtitle":
      "キュレーション済み寄付ポートフォリオの作成と管理",
    "admin.portfolio.newFund": "新規ファンド",
    "admin.portfolio.editFund": "ファンドを編集",
    "admin.portfolio.createNewFund": "新規ファンドを作成",
    "admin.portfolio.fundName": "ファンド名",
    "admin.portfolio.fundNamePlaceholder": "例：環境インパクトファンド",
    "admin.portfolio.description": "説明",
    "admin.portfolio.descriptionPlaceholder":
      "ファンドの目的とインパクトの焦点を記述してください...",
    "admin.portfolio.category": "カテゴリ",
    "admin.portfolio.selectCategory": "カテゴリを選択",
    "admin.portfolio.imageUrl": "画像URL",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities":
      "チャリティを選択（{{count}}件選択済み）",
    "admin.portfolio.noCharitiesFound": "認証済みチャリティが見つかりません",
    "admin.portfolio.saving": "保存中...",
    "admin.portfolio.createFund": "ファンドを作成",
    "admin.portfolio.updateFund": "ファンドを更新",
    "admin.portfolio.noFundsYet": "まだポートフォリオファンドがありません",
    "admin.portfolio.noFundsMessage":
      "最初のファンドを作成して、チャリティをグループ化し一括寄付を可能にしましょう",
    "admin.portfolio.charity": "チャリティ",
    "admin.portfolio.charities": "チャリティ",
    "admin.portfolio.createdOn": "作成日：{{date}}",
    "admin.portfolio.statusActive": "アクティブ",
    "admin.portfolio.statusPaused": "一時停止",
    "admin.portfolio.statusArchived": "アーカイブ済み",
    "admin.portfolio.errorLoad": "データの読み込みに失敗しました",
    "admin.portfolio.errorArchive": "ファンドのアーカイブに失敗しました",
    "admin.portfolio.fundArchived": "ファンドをアーカイブしました",
    "admin.portfolio.fundUpdated": "ファンドを更新しました",
    "admin.portfolio.fundCreated": "ファンドを作成しました",
    "admin.portfolio.errorSave": "ファンドの保存に失敗しました",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "チャリティ管理",
    "admin.charity.totalCount": "合計{{count}}件",
    "admin.charity.allStatuses": "すべてのステータス",
    "admin.charity.searchPlaceholder": "名前で検索\u2026",
    "admin.charity.colName": "名前",
    "admin.charity.colEin": "納税者番号",
    "admin.charity.taxIdDisplay": "納税者番号 {{value}}",
    "admin.charity.searchByNameEin": "名前または納税者番号で検索…",
    "admin.charity.colCategory": "カテゴリ",
    "admin.charity.colStatus": "ステータス",
    "admin.charity.colSigner": "連絡先",
    "admin.charity.colJoined": "登録日",
    "admin.charity.colWallet": "ウォレット",
    "admin.charity.colActions": "操作",
    "admin.charity.walletNotSet": "未設定",
    "admin.charity.approve": "承認",
    "admin.charity.reject": "却下",
    "admin.charity.suspend": "停止",
    "admin.charity.reinstate": "復元",
    "admin.charity.statusPending": "保留中",
    "admin.charity.statusVerified": "認証済み",
    "admin.charity.statusApproved": "承認済み",
    "admin.charity.statusRejected": "却下済み",
    "admin.charity.statusSuspended": "停止済み",
    "admin.charity.approveTitle": "チャリティを承認",
    "admin.charity.rejectTitle": "チャリティを却下",
    "admin.charity.suspendTitle": "チャリティを停止",
    "admin.charity.reinstateTitle": "チャリティを復元",
    "admin.charity.confirmAction": "操作を確認",
    "admin.charity.reasonRequired": "理由（必須）",
    "admin.charity.reasonOptional": "理由（任意）",
    "admin.charity.saving": "保存中\u2026",
    "admin.charity.confirm": "確認",
    "admin.charity.noResults":
      "フィルター条件に一致するチャリティが見つかりません。",
    "admin.charity.unnamed": "名称未設定の団体",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "チャリティリクエスト",
    "admin.charityRequests.subtitle":
      "寄付者から提出された未登録チャリティへのリクエストです。組織ごとにグループ化されています。関心の高い団体を優先してアウトリーチを行ってください。",
    "admin.charityRequests.ein": "納税者番号",
    "admin.charityRequests.requests": "リクエスト数",
    "admin.charityRequests.latestRequester": "最新のリクエスター",
    "admin.charityRequests.latestRequest": "最新のリクエスト",
    "admin.charityRequests.firstRequest": "最初のリクエスト",
    "admin.charityRequests.empty":
      "チャリティリクエストはまだ提出されていません。",
    "admin.charityRequests.errorTitle": "チャリティリクエストの読み込みエラー",
    "admin.charityRequests.showing":
      "{{total}}件中{{shown}}件のユニークな組織を表示しています。",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "ボランティア検証管理",
    "admin.validation.totalCount": "合計{{count}}件のリクエスト",
    "admin.validation.pipelineStats": "パイプライン統計",
    "admin.validation.noStats": "統計情報はありません。",
    "admin.validation.pending": "保留中",
    "admin.validation.approved": "承認済み",
    "admin.validation.rejected": "却下済み",
    "admin.validation.expired": "期限切れ",
    "admin.validation.avgResponseTime": "平均応答時間：",
    "admin.validation.expirationRate": "期限切れ率：",
    "admin.validation.rejectionRate": "却下率：",
    "admin.validation.searchPlaceholder": "ボランティア、団体を検索\u2026",
    "admin.validation.requestsTab": "検証リクエスト",
    "admin.validation.patternsTab": "不審なパターン",
    "admin.validation.colVolunteer": "ボランティア",
    "admin.validation.colOrganisation": "団体",
    "admin.validation.colHours": "時間",
    "admin.validation.colActivityDate": "活動日",
    "admin.validation.colHrsPerWeek": "時間/週",
    "admin.validation.colTotalRequests": "総リクエスト数",
    "admin.validation.override": "オーバーライド",
    "admin.validation.noPatterns": "不審なパターンは検出されませんでした。",
    "admin.validation.noRequests": "検証リクエストが見つかりません。",
    "admin.validation.patternsDescription":
      "7日間のローリングウィンドウで設定されたしきい値を超える時間を報告したボランティアにフラグが付けられています。これらのパターンは、自己申告時間システムの悪用を示している可能性があります。",
    "admin.validation.overrideTitle": "検証リクエストをオーバーライド",
    "admin.validation.newStatus": "新しいステータス",
    "admin.validation.reasonRequired": "理由（必須）",
    "admin.validation.reasonPlaceholder":
      "このリクエストをオーバーライドする理由を説明してください\u2026",
    "admin.validation.saving": "保存中\u2026",
    "admin.validation.confirmOverride": "オーバーライドを確認",
    "admin.validation.allStatuses": "すべてのステータス",
    "admin.validation.colStatus": "ステータス",
    "admin.validation.colCreated": "作成日",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "透明な寄付",
    "home.hero.titleAccent": "持続可能なインパクト",
    "home.hero.description":
      "デジタル時代のための徹底的に透明なフィランソロピー。インパクトのために構築され、検証可能な技術に支えられています。すべての寄付が寄付者から届け先まで追跡可能です。",
    "home.hero.visionTitle": "私たちのビジョン",
    "home.hero.visionText":
      "Give Protocolは、高い信頼性を備えた寄付の未来を構築しています。先進的な技術基盤を活用し、世界の資本とローカルなインパクトの間のギャップを埋めます。シームレスなデジタル資産サポートと従来の寄付方法を統合することで、一度きりの寄付を、世界で最も重要な活動を支える永続的な支援エンジンへと変える、持続可能な資金調達エコシステムを構築しています。",
    "home.comingSoon": "近日公開",
    "home.readDocs": "ドキュメントを読む",
    "home.features.sectionTitle": "透明なフィランソロピーへのゲートウェイ",
    "home.features.sectionSubtitle":
      "暗号資産でも法定通貨でも、完全な透明性を備えたシームレスな寄付のためのマルチチェーンインフラストラクチャ",
    "home.features.highEfficiency.title": "高効率な寄付",
    "home.features.highEfficiency.description":
      "認証済みの団体に曖昧さなく直接寄付できます。自動化された台帳がリアルタイムの検証を提供し、あなたの支援が最も必要とされる場所に確実に届けられます。",
    "home.features.equityFunds.title": "チャリタブル・エクイティ・ファンド",
    "home.features.equityFunds.description":
      "一度きりの寄付を超え、スマート運用のエクイティファンドに寄付しましょう。低リスクのデジタル戦略を活用し、元本を永続的な資金の流れに変え、慈善活動を世代を超えて支えます。",
    "home.features.impactFunds.title": "インパクトファンド",
    "home.features.impactFunds.description":
      "特定の活動に資金をプールできます。環境、教育、貧困救済など、集団的な行動を通じてあなたの寄付が増幅されます。",
    "home.features.verifiedOrgs.title": "認証済み団体",
    "home.features.verifiedOrgs.description":
      "登録済みのすべての団体を閲覧したり、認証バッジを探したりできます。審査プロセスに参加した団体は、寄付者が信頼できるオンチェーン認証を取得しています。",
    "home.features.blockchainVerified.title": "ブロックチェーン認証",
    "home.features.blockchainVerified.description":
      "ソウルバウンドトークンがボランティアの貢献を認証します。スキル、活動時間、インパクトのすべてがオンチェーンに永続的に記録されます。",
    "home.features.bridgingModes.title": "寄付方法の架け橋",
    "home.features.bridgingModes.description":
      "USDでもデジタル資産でも、マルチネットワークアーキテクチャにより、現代のスピードであなたの寄付が届けられます。",
    "home.roles.title": "世界を変えるすべての人のために",
    "home.roles.donors.title": "寄付者の方へ",
    "home.roles.donors.item1": "暗号資産でも法定通貨でも — お好みの方法で",
    "home.roles.donors.item2": "ガバナンスへの参加",
    "home.roles.donors.item3": "オンチェーンでのレピュテーション構築",
    "home.roles.nonprofits.title": "非営利団体の方へ",
    "home.roles.nonprofits.item1": "新しい寄付者層へのアクセス",
    "home.roles.nonprofits.item2": "CEFによる持続可能な資金調達",
    "home.roles.nonprofits.item3": "強化された透明性レポート",
    "home.roles.volunteers.title": "ボランティアの方へ",
    "home.roles.volunteers.item1": "検証可能な活動記録",
    "home.roles.volunteers.item2": "ポータブルなスキル証明（SBT）",
    "home.roles.volunteers.item3": "実績バッジと表彰",
    "home.impact.title": "インパクトファンド計画",
    "home.impact.environmental.title": "環境インパクトファンド",
    "home.impact.environmental.description":
      "森林再生、海洋清掃、再生可能エネルギーの取り組みを支援します。プールされた寄付金が、測定可能なインパクトを生み出す認証済み環境団体に届けられます。",
    "home.impact.education.title": "教育機会ファンド",
    "home.impact.education.description":
      "奨学金、デジタル学習ツール、教員研修を提供します。集約された資金が、教育機会の乏しい地域の教育活動を支援するために活用されます。",
    "home.cta.title": "寄付を変革する準備はできましたか？",
    "home.cta.subtitle":
      "透明でブロックチェーンを活用したフィランソロピーをいち早く体験しましょう。慈善活動のより良い未来を築くコミュニティにご参加ください。",
    "home.cta.explore": "活動を探す",
    "home.nav.features": "特長",
    "home.nav.impact": "インパクト",
    "home.nav.charities": "チャリティ",
    "home.nav.volunteer": "ボランティア",
    "home.footer.brand.tagline":
      "ブロックチェーンの透明性と持続可能な資金調達を通じてフィランソロピーを変革します。",
    "home.footer.product.title": "プロダクト",
    "home.footer.product.impactFunds": "インパクトファンド",
    "home.footer.product.charities": "チャリティ向け",
    "home.footer.product.volunteers": "ボランティア向け",
    "home.footer.resources.title": "リソース",
    "home.footer.resources.whitepaper": "ホワイトペーパー（近日公開）",
    "home.footer.resources.blog": "ブログ（近日公開）",
    "home.footer.resources.community": "コミュニティ（近日公開）",
    "home.footer.connect.title": "つながる",
    "home.footer.connect.contact": "お問い合わせ（近日公開）",
    "home.footer.copyright":
      "Give Protocol. マルチチェーン設計。Give Protocolボランティアによって運営されています。",
    "auth.signin.welcomeBack": "おかえりなさい",
    "auth.signin.subtitle": "Give Protocolアカウントにサインイン",
    "auth.signin.emailPlaceholder": "メールアドレス",
    "auth.signin.passwordPlaceholder": "パスワード",
    "auth.signin.submitting": "サインイン中…",
    "auth.signin.withPasskey": "パスキーでサインイン",
    "auth.signin.withGoogle": "Googleで続行",
    "auth.signin.or": "または",
    "auth.signin.newToProtocol": "Give Protocolは初めてですか？",
    "auth.signin.createAccount": "アカウントを作成 →",
    "auth.signin.forgotPasswordLink": "パスワードをお忘れですか？ →",
    "auth.signin.sslEncrypted": "TLS暗号化",
    "auth.signin.modeToggleLabel": "サインイン方法",
    "auth.signin.terms": "利用規約",
    "auth.signin.privacy": "プライバシー",
    "auth.panel.headline": "スマートな寄付、透明なインパクト。",
    "auth.panel.subheadline":
      "ひとつのアカウントで。カードでも暗号資産でも寄付。すべてをオンチェーンで追跡。",
    "auth.panel.statusLabel": "プロトコル状況 · ジェネシスフェーズ",
    "auth.panel.statusDesc": "透明な寄付の基盤を構築中",
    "auth.panel.runsOn": "基盤技術",
    "auth.wallet.connect": "ウォレットを接続",
    "auth.wallet.connecting": "ウォレットを接続中…",
    "auth.wallet.signing": "メッセージに署名中…",
    "auth.wallet.verifying": "検証中…",
    "auth.wallet.openingSession": "セッションを開始中…",
    "auth.validation.emailRequired": "まずメールアドレスを入力してください",
    "auth.validation.invalidEmail": "有効なメールアドレスを入力してください",
    "auth.validation.passwordTooShort":
      "パスワードは8文字以上で入力してください",
    "auth.validation.passwordMismatch": "パスワードが一致しません",
    "auth.login.welcomeHeading": "Give Protocolへようこそ",
    "auth.login.signInOrConnect": "サインインまたは接続",
    "auth.login.skipToContent": "ログインコンテンツへスキップ",
    "auth.login.donorTitle": "寄付者サインイン",
    "auth.login.donorSubtitle":
      "寄付ダッシュボードにアクセスするにはサインインしてください",
    "auth.login.charityTitle": "非営利団体ポータル",
    "auth.login.charitySubtitle": "団体プロフィールと寄付金を管理",
    "auth.login.back": "← 戻る",
    "auth.login.continueDonor": "寄付者として続行",
    "auth.login.connecting": "接続中…",
    "auth.login.connectWalletSignIn": "ウォレットを接続してサインイン",
    "auth.login.newToPlatform": "Give Protocolは初めてですか？",
    "auth.login.newDonorSignUp": "新規寄付者登録",
    "auth.login.manageNonprofit": "非営利団体を管理しています",
    "auth.login.nonprofitTrayTitle": "Give Protocolは初めてですか？",
    "auth.login.createNonprofitAccount": "非営利団体アカウントを作成",
    "auth.login.registerOrg": "Give Protocolに団体を登録",
    "auth.login.needHelp": "お困りですか？",
    "auth.login.forgotUsernameBtn": "ユーザー名をお忘れですか？",
    "auth.login.forgotPasswordBtn": "パスワードをお忘れですか？",
    "auth.donorLogin.mismatch":
      "寄付者アカウントが見つかりません。このメールアドレスはチャリティアカウントとして登録されています。チャリティログインをご利用ください。",
    "auth.donorLogin.signingIn": "サインイン中…",
    "auth.donorLogin.redirecting": "{{count}}秒後にリダイレクトします...",
    "auth.donorReg.pleaseWait": "お待ちください…",
    "auth.donorReg.signUpPasskey": "パスキーで登録",
    "auth.donorReg.withGoogle": "Googleで続行",
    "auth.donorReg.connectWallet": "ウォレットを接続",
    "auth.donorReg.orSetPassword": "またはパスワードを設定",
    "auth.donorReg.creating": "アカウントを作成中...",
    "auth.donorReg.createAccount": "寄付者アカウントを作成",
    "auth.donorReg.privacyNotice":
      "アカウントを作成すると、以下に同意したことになります：",
    "auth.donorReg.termsLink": "利用規約",
    "auth.donorReg.privacyAnd": "および",
    "auth.donorReg.privacyLink": "プライバシーポリシー",
    "auth.charityLogin.mismatch":
      "このメールアドレスは寄付者アカウントとして登録されています。寄付者ポータルからサインインしてください。",
    "auth.charityLogin.signingIn": "サインイン中...",
    "auth.charityLogin.or": "または",
    "auth.charityLogin.connecting": "接続中...",
    "auth.charityLogin.connectWallet": "ウォレットを接続",
    "auth.forgot.resetPassword": "パスワードのリセット",
    "auth.forgot.forgotUsername": "ユーザー名をお忘れの方",
    "auth.forgot.passwordDesc":
      "メールアドレスを入力してください。パスワードリセット用のリンクをお送りします。",
    "auth.forgot.usernameDesc":
      "メールアドレスを入力してください。ユーザー名をお送りします。",
    "auth.forgot.passwordSuccess":
      "パスワードリセットの手順をメールで送信しました",
    "auth.forgot.usernameSuccess":
      "ユーザー名のリマインダーをメールで送信しました",
    "auth.forgot.checkEmail": "メールをご確認ください",
    "auth.forgot.backToSignIn": "サインインに戻る",
    "auth.forgot.emailPlaceholder": "メールアドレスを入力",
    "auth.forgot.genericError":
      "エラーが発生しました。もう一度お試しください。",
    "auth.forgot.sending": "送信中...",
    "auth.forgot.sendResetLink": "リセットリンクを送信",
    "auth.forgot.sendUsername": "ユーザー名を送信",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "団体名",
    "auth.orgSearch.searchPlaceholder": "団体名で検索...",
    "auth.orgSearch.countryLabel": "国",
    "auth.orgSearch.allCountries": "すべての国",
    "auth.orgSearch.searchPrompt":
      "データベースを検索して、あなたの団体を見つけて申請してください。",
    "auth.orgSearch.noResults": "団体が見つかりませんでした。",
    "auth.orgSearch.loadMore": "さらに表示",
    "auth.orgSearch.cantFind": "お探しの団体が見つかりませんか？",
    "auth.orgSearch.registerManually": "手動で登録",
    "charity.claim.orgDetails": "団体情報（登録データより）",
    "charity.claim.orgNameLabel": "団体名",
    "charity.claim.einLabel": "納税者番号",
    "charity.claim.locationLabel": "所在地",
    "charity.claim.contactInfo": "連絡先情報",
    "charity.claim.contactName": "担当者名",
    "charity.claim.contactEmail": "連絡先メールアドレス",
    "charity.claim.accountSecurity": "アカウントセキュリティ",
    "charity.claim.password": "パスワード",
    "charity.claim.confirmPassword": "パスワード確認",
    "charity.claim.backToSearch": "検索に戻る",
    "charity.claim.creating": "アカウントを作成中...",
    "charity.claim.submit": "団体を申請",
    "charity.claim.validation.name":
      "名前は2文字以上100文字以内で入力してください",
    "charity.claim.validation.email": "有効なメールアドレスを入力してください",
    "charity.claim.validation.password":
      "パスワードは8文字以上で入力してください",
    "charity.claim.validation.confirmPassword": "パスワードが一致しません",
    "charity.claim.validation.fix": "入力エラーを修正してください",
    "charity.claim.useAsPublicEmail":
      "自分のメールアドレスを団体の公開連絡先メールアドレスとして使用する",
    "charity.claim.publicContactEmail": "団体の公開連絡先メールアドレス",
    "charity.claim.privacyNotice":
      "個人の署名者メール/電話番号は本人確認のみに使用され、他のプラットフォームユーザーには表示されません。公開連絡先メールアドレスは団体プロフィールに表示されます。",
    "charity.claim.secondContactTitle": "第2の連絡先",
    "charity.claim.secondContactName": "第2連絡先の氏名",
    "charity.claim.secondContactEmail": "第2連絡先のメールアドレス",
    "charity.claim.secondContactHint":
      "団体のウォレットまたは支払いの詳細が変更された際に通知される別の方。",
    "charity.claim.validation.secondEmailDistinct":
      "第2連絡先のメールアドレスはプライマリメールアドレスと異なる必要があります",
    "charity.claim.error.creation": "アカウントの作成に失敗しました",
    "charity.claim.error.generic": "アカウントを作成できませんでした",
    "charity.vetting.orgDetails": "団体情報",
    "charity.vetting.orgName": "団体名",
    "charity.vetting.description": "説明",
    "charity.vetting.taxId": "納税者番号または登録番号",
    "charity.vetting.countryLabel": "国",
    "charity.vetting.selectCountry": "国を選択",
    "charity.vetting.address": "住所",
    "charity.vetting.streetAddress": "番地・通り",
    "charity.vetting.city": "市区町村",
    "charity.vetting.state": "都道府県",
    "charity.vetting.postalCode": "郵便番号",
    "charity.vetting.contactInfo": "連絡先情報",
    "charity.vetting.contactName": "担当者名",
    "charity.vetting.contactEmail": "連絡先メールアドレス",
    "charity.vetting.accountSecurity": "アカウントセキュリティ",
    "charity.vetting.password": "パスワード",
    "charity.vetting.confirmPassword": "パスワード確認",
    "charity.vetting.submitting": "申請を送信中...",
    "charity.vetting.submit": "チャリティ申請を提出",
    "charity.vetting.validation.orgName":
      "団体名は2文字以上100文字以内で入力してください",
    "charity.vetting.validation.contactName":
      "担当者名は2文字以上100文字以内で入力してください",
    "charity.vetting.validation.email":
      "有効なメールアドレスを入力してください",
    "charity.vetting.validation.password":
      "パスワードは8文字以上で入力してください",
    "charity.vetting.validation.confirmPassword": "パスワードが一致しません",
    "charity.vetting.validation.description": "説明は必須です",
    "charity.vetting.validation.category": "カテゴリは必須です",
    "charity.vetting.validation.taxId": "納税者番号は必須です",
    "charity.vetting.validation.streetAddress": "番地・通りは必須です",
    "charity.vetting.validation.city": "市区町村は必須です",
    "charity.vetting.validation.country": "国は必須です",
    "charity.vetting.validation.fix": "入力エラーを修正してください",
    "charity.vetting.error.generic": "申請の送信に失敗しました",
    "charity.vetting.privacyNotice":
      "この申請を送信すると、以下に同意したことになります：",
    "charity.vetting.termsLink": "利用規約",
    "charity.vetting.privacyAnd": "および",
    "charity.vetting.privacyLink": "プライバシーポリシー",
    "common.email": "メールアドレス",
    "common.password": "パスワード",
    "common.confirmPassword": "パスワード確認",
    "footer.brand.tagline": "持続可能な慈善寄付への障壁を取り除きます。",
    "footer.resources.title": "リソース",
    "footer.resources.faq": "よくある質問",
    "footer.resources.about": "私たちについて",
    "footer.legal.title": "法的情報",
    "footer.legal.terms": "利用規約",
    "footer.legal.privacy": "プライバシーポリシー",
    "footer.legal.cookiePreferences": "Cookie設定",
    "consent.banner.ariaLabel": "Cookieの同意",
    "consent.banner.body":
      "アプリの利用状況の把握やエラーの検出のために、Google Analytics 4（Google LLC、米国）およびSentry（Functional Software、米国/EU）を使用しています。メールアドレス、ウォレットアドレス、寄付者名が共有されることはありません。同意はいつでも撤回できます。",
    "consent.banner.privacyLink": "プライバシーポリシー",
    "consent.banner.acceptAll": "すべて受け入れる",
    "consent.banner.decline": "必須でないものを拒否",
    "consent.banner.customize": "カスタマイズ",
    "consent.modal.title": "Cookie設定",
    "consent.modal.essentialTitle": "必須",
    "consent.modal.essentialDesc":
      "ナビゲーションや認証などの基本的なサイト機能に必要です。無効にすることはできません。",
    "consent.modal.essentialAlwaysOn": "必須Cookie — 常に有効",
    "consent.modal.analyticsTitle":
      "分析（Google Analytics 4 · 米国、Sentry · 米国/EU）",
    "consent.modal.analyticsDesc":
      "分析Cookieは、どのページが閲覧されているか、ユーザーがアプリ内でどのように移動しているかを理解するのに役立ちます。Google Analytics 4を使用しています \u2014 セッション識別子、ページURL、デバイス/ブラウザのメタデータ、匿名化されたIPからのおおよその位置情報（Google LLC、米国；SCCs + EU\u2013US Data Privacy Framework）。Sentry \u2014 信頼性監視のための匿名化されたエラートレースとブラウザメタデータ（Functional Software、EU/米国；転送メカニズム保留中）。メールアドレス、ウォレットアドレス、寄付者名がいずれの処理者とも共有されることはありません。",
    "consent.modal.analyticsOn": "分析とエラー記録 — オン",
    "consent.modal.analyticsOff": "分析とエラー記録 — オフ",
    "consent.modal.cancel": "キャンセル",
    "consent.modal.save": "設定を保存",
    "footer.connect.title": "つながる",
    "footer.copyright": "Give Protocol. All rights reserved.",
    "nav.signIn": "サインイン",
    "nav.signOut": "サインアウト",
    "nav.privacy": "プライバシー",
    "auth.signup.heading": "アカウントを作成",
    "auth.signup.subtitle": "透明な寄付の活動に参加しましょう",
    "auth.signup.displayName": "表示名",
    "auth.signup.emailPlaceholder": "メールアドレス",
    "auth.signup.passwordPlaceholder": "パスワード",
    "auth.signup.confirmPasswordPlaceholder": "パスワード確認",
    "auth.signup.submit": "アカウントを作成",
    "auth.signup.submitting": "アカウントを作成中…",
    "auth.signup.withPasskey": "パスキーで登録",
    "auth.signup.withGoogle": "Googleで続行",
    "auth.signup.connectWallet": "ウォレットを接続",
    "auth.signup.orSetPassword": "またはパスワードを設定",
    "auth.signup.alreadyHaveAccount": "すでにアカウントをお持ちですか？",
    "auth.signup.signInLink": "サインイン",
    "auth.signup.manageNonprofit": "非営利団体を管理しますか？",
    "auth.signup.trustText": "あなたのデータは以下で保護されています",
    "auth.signup.and": "および",
    "auth.signup.privacyPolicy": "プライバシーポリシー",
    "auth.signup.panel.headline": "検証できる寄付を。",
    "browse.hero.title": "オンチェーンで検証される寄付。",
    "browse.hero.subtitle":
      "審査済みの寄付先を発見し、カードまたはデジタル資産で寄付して、あなたの時間とリソースが生み出す確かな変化を確認できます。",
    "browse.stats.networks": "対応ネットワーク",
    "browse.stats.sectors": "慈善分野",
    "browse.stats.verifiedOrgs": "認証済み団体",
    "browse.stats.volunteerHours": "ボランティア時間",
    "browse.verified": "認証済み",
    "browse.donate": "寄付する",
    "browse.viewProfile": "プロフィールを見る",
    "browse.filter.ariaLabel": "チャリティを絞り込む",
    "browse.filter.searchAria": "チャリティを検索",
    "browse.filter.locationAria": "地域を検索",
    "browse.results.ariaLabel": "チャリティ検索結果",
    "browse.tabs.charities": "チャリティ",
    "browse.tabs.causes": "活動",
    "browse.tabs.funds": "ポートフォリオファンド",
    "browse.tabs.ariaLabel": "カテゴリを閲覧",
    "browse.featured.heading": "注目の団体",
    "browse.featured.ariaLabel": "注目の団体",
    "browse.featured.nextAria": "次の注目団体",
    "browse.causes.heading": "注目の活動",
    "browse.causes.ariaLabel": "注目の活動",
    "browse.causes.badge": "活動",
    "browse.causes.raised": "調達済み",
    "browse.causes.percentOf": "% /",
    "browse.causes.by": "by",
    "browse.causes.supportCta": "この活動を支援",
    "browse.causes.giveCta": "寄付",
    "browse.causes.nextAria": "次の注目活動",
    "browse.funds.heading": "ポートフォリオファンド",
    "browse.funds.ariaLabel": "ポートフォリオファンド",
    "browse.funds.badge": "ポートフォリオファンド",
    "browse.funds.charity": "団体",
    "browse.funds.charities": "団体",
    "browse.funds.donateCta": "ファンドに寄付",
    "browse.funds.nextAria": "次のポートフォリオファンド",
    "portfolio.notFound.title": "ポートフォリオファンドが見つかりません",
    "portfolio.notFound.body":
      "お探しのポートフォリオファンドは存在しないか、現在有効ではありません。",
    "portfolio.supportedOrgs": "支援団体",
    "browse.charity.einLabel": "納税者番号",
    "browse.charity.einDisplay": "納税者番号: {{value}}",
    "browse.charity.nteeLabel": "セクターコード",
    "browse.charity.deductibilityLabel": "控除適格性",
    "browse.charity.onPlatform": "プラットフォーム上",
    "browse.charity.loading": "読み込み中…",
    "browse.charity.loadMore": "さらに表示",
    "browse.filter.searchPlaceholder": "チャリティを検索...",
    "browse.filter.locationPlaceholder": "市区町村、都道府県、または国...",
    "browse.whyGiveProtocol.heading": "Give Protocolを選ぶ理由",
    "browse.whyGiveProtocol.verified.title": "認証済み非営利団体",
    "browse.whyGiveProtocol.verified.description":
      "すべての団体は、プラットフォームに掲載される前に公的登記簿と照合されます。",
    "browse.whyGiveProtocol.onchain.title": "オンチェーンの透明性",
    "browse.whyGiveProtocol.onchain.description":
      "寄付はブロックチェーンに記録され、ウォレットから支援先までの影響を追跡できます。",
    "browse.whyGiveProtocol.volunteer.title":
      "お金だけでなく、時間も寄付しよう",
    "browse.whyGiveProtocol.volunteer.description":
      "ボランティア時間は団体によって検証され、プロトコルでの評判に反映されます。",
    "browse.news.heading": "プラットフォームニュース",
    "admin.news.deleteConfirmBody": "「{{title}}」は完全に削除されます。この操作は元に戻せません。",
    "admin.news.deleteConfirmTitle": "ニュースを削除しますか？",
    "admin.news.saveFailed": "変更を保存できませんでした。もう一度お試しください。",
    "admin.news.urlHelp": "任意。空欄の場合、リンクなしで表示されます。",
    "admin.news.urlInvalid": "https:// で始まる完全なアドレス、または / で始まるパスを入力してください。",
    "browse.carousel.error": "このセクションを読み込めませんでした。ページを再読み込みしてもう一度お試しください。",
    "browse.carousel.goToPage": "{{page}} ページ目へ移動",
    "browse.carousel.pageLabel": "{{current}} / {{total}} ページ",
    "browse.carousel.pause": "自動切り替えを一時停止",
    "browse.carousel.play": "自動切り替えを再開",
    "browse.causes.empty": "まだ活動はありません。またのご確認をお待ちしています。",
    "browse.causes.prevAria": "前の注目の活動",
    "browse.causes.searchPlaceholder": "活動を検索...",
    "browse.causes.subheading": "実際に成果を生む具体的なプロジェクトを支援しましょう。",
    "browse.charity.registryIdDisplay": "登録ID：{{value}}",
    "browse.featured.empty": "注目の団体はまだありません。上の検索でチャリティを探してください。",
    "browse.featured.prevAria": "前の注目の団体",
    "browse.featured.subheading": "Give Protocol で認証されたチャリティを順にご紹介します。",
    "browse.filter.addLocation": "場所を追加",
    "browse.filter.impactNotice": "影響地域によるフィルターはまだ利用できないため、結果は影響地域では絞り込まれません。",
    "browse.filter.locationHint": "Enter キーを押すか「追加」を選択して場所を適用します。",
    "browse.filter.minChars": "検索するには2文字以上入力してください。",
    "browse.funds.empty": "ポートフォリオファンドはまだありません。またのご確認をお待ちしています。",
    "browse.funds.prevAria": "前のポートフォリオファンド",
    "browse.funds.searchPlaceholder": "ポートフォリオファンドを検索...",
    "browse.funds.subheading": "認証済みのチャリティに寄付を分配する、厳選された寄付ポートフォリオ。",
    "browse.registry.badge": "{{registry}}登録",
    "browse.results.empty": "この検索条件に一致する団体はまだありません。別のキーワードを試すか、場所フィルターを追加してください。",
    "browse.results.error": "検索を実行できませんでした。もう一度お試しください。",
    "browse.search.noMatches": "「{{query}}」に一致するものはありません。",
    "browse.category.A": "芸術・文化",
    "browse.category.B": "教育",
    "browse.category.C": "環境",
    "browse.category.D": "動物福祉",
    "browse.category.E": "健康",
    "browse.category.F": "メンタルヘルス",
    "browse.category.G": "医学研究",
    "browse.category.H": "生物医学研究",
    "browse.category.I": "犯罪・法務",
    "browse.category.J": "雇用",
    "browse.category.K": "食料・栄養",
    "browse.category.L": "住宅",
    "browse.category.M": "公共の安全",
    "browse.category.N": "レクリエーション",
    "browse.category.O": "青少年育成",
    "browse.category.P": "人間サービス",
    "browse.category.Q": "国際",
    "browse.category.R": "市民権",
    "browse.category.S": "地域開発",
    "browse.category.T": "フィランソロピー",
    "browse.category.U": "科学・技術",
    "browse.category.V": "社会科学",
    "browse.category.W": "公共政策",
    "browse.category.X": "宗教",
    "browse.category.Y": "相互利益",
    "browse.category.default": "非営利団体",
    "cause.causes": "活動",
    "cause.createNew": "新規作成",
    "cause.noCausesTitle": "まだ活動がありません",
    "cause.name": "名称",
    "cause.description": "説明",
    "cause.category": "カテゴリ",
    "cause.targetAmount": "目標金額",
    "cause.headerImage": "ヘッダー画像",
    "cause.impact": "インパクト",
    "cause.impactHelp": "この活動で期待されるインパクトを記述してください。",
    "cause.location": "所在地",
    "cause.timeline": "タイムライン",
    "cause.partners": "パートナー",
    "cause.limitReached": "活動数の上限に達しました",
    "impact.statistics": "インパクト統計",
    "impact.statLabel": "ラベル",
    "impact.statValue": "値",
    "impact.missionStatement": "ミッションステートメント",
    "impact.missionPlaceholder": "私たちのミッションは...",
    "impact.highlights": "インパクトのハイライト",
    "impact.highlight": "インパクトハイライト",
    "impact.addHighlight": "ハイライトを追加",
    "impact.profile": "インパクトプロフィール",
    "impact.loadError": "インパクトプロフィールの読み込みに失敗しました",
    "impact.saveError": "インパクトプロフィールの保存に失敗しました",
    "impact.saveSuccess": "インパクトプロフィールを保存しました",
    "organization.yearFounded": "設立年",
    "organization.address": "住所",
    "organization.street": "番地・通り",
    "organization.city": "市区町村",
    "organization.stateProvince": "都道府県",
    "organization.postalCode": "郵便番号",
    "organization.country": "国",
    "organization.contactInfo": "連絡先情報",
    "organization.phone": "電話番号",
    "organization.email": "メールアドレス",
    "organization.website": "ウェブサイト",
    "organization.socialMedia": "ソーシャルメディア",
    "organization.publicFeed": "公開フィード",
    "organization.communityMedia": "コミュニティ＆メディア",
    "organization.profile": "団体プロフィール",
    "organization.loadError": "団体プロフィールの読み込みに失敗しました",
    "organization.saveError": "団体プロフィールの保存に失敗しました",
    "common.remove": "削除",
    "common.saveChanges": "変更を保存",
    "dashboard.thisMonth": "今月",
    "dashboard.verified": "認証済みボランティア",
    "dashboard.hoursLogged": "記録された時間",
    "dashboard.endorsements": "推薦",
    "dashboard.organizationsHelped": "支援した団体",
    "dashboard.yourOrganizationsHelped": "あなたが支援した団体",
    "transactions.createCampaign": "最初のキャンペーンを作成",
    "contributions.emptyTitle": "あなたの寄付の旅はここから始まります",
    "contributions.browseCharities": "チャリティを探す",
    "charity.profile.verified501c3": "認証済み非営利団体",
    "charity.profile.verified501c3Tooltip":
      "登録済み501(c)(3) — 米国では寄付が税控除の対象となる場合があります",
    "charity.profile.statusClaimed": "申請済み",
    "charity.profile.statusUnclaimed": "未申請 — 公的登録データのみ",
    "charity.profile.statusIrsVerified": "IRS認証済み非営利団体",
    "charity.profile.requestWidget.unclaimedBody":
      "この組織はまだGive Protocol上でプロフィールの所有権を登録していません。プロフィールの所有権登録とウォレット設定が完了すると、寄付できるようになります。",
    "charity.profile.rowEin": "納税者番号",
    "charity.profile.rowName": "名称",
    "charity.profile.rowLocation": "所在地",
    "charity.profile.rowRulingYear": "登録年",
    "charity.profile.rowNteeCode": "セクターコード",
    "charity.profile.rowDeductibility": "控除適格性",
    "charity.profile.rowAffiliation": "所属",
    "charity.profile.rowClassification": "分類",
    "charity.profile.rowFoundation": "財団類型",
    "charity.profile.rowActivityCodes": "活動コード",
    "charity.profile.rowOrgType": "団体種別",
    "charity.profile.rowSubsection": "サブセクション",
    "charity.profile.rowStatus": "ステータス",
    "charity.profile.registryRecord": "登録簿の公開記録",
    "charity.profile.einDisplay": "納税者番号",
    "charity.profile.charityNotFoundByTaxId":
      "この納税者番号のチャリティが見つかりませんでした。",
    "charity.profile.registeredNonprofit": "登録済み非営利団体",
    "charity.profile.registeredYear": "{{year}}年登録",
    "charity.profile.shareAria": "共有",
    "charity.profile.copied": "コピーしました！",
    "charity.profile.about": "概要",
    "charity.profile.claimProfile": "このプロフィールを申請",
    "charity.profile.noDescription": "説明はまだありません。",
    "charity.profile.toAddOne": "追加するには。",
    "charity.profile.contact": "お問い合わせ",
    "charity.profile.donate.support": "支援する",
    "charity.profile.donate.walletUnset":
      "この団体はまだ公式の受取ウォレットを設定していません。",
    "charity.profile.donate.walletPending":
      "この団体はウォレットの設定中です — 寄付は一時的に利用できません。",
    "charity.profile.donate.walletLegacy":
      "この団体はレガシーウォレットアドレスを使用しています。",
    "charity.profile.donate.feeNote":
      "直接寄付のプラットフォーム手数料は0%です。ネットワーク手数料が適用されます。",
    "charity.profile.donate.jurisdictionUnavailable":
      "米国以外の慈善団体への寄付は、Give Protocolではまだご利用いただけません。",
    "portfolio.title": "ポートフォリオファンド",
    "settings.displayPreferences": "表示設定",
    "settings.theme": "テーマ",
    "settings.light": "ライト",
    "settings.dark": "ダーク",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "私の寄付記録が{{charity}}と私を結びつけることを理解しています。これが宗教的、政治的、または哲学的な所属を示す可能性がある場合、私は寄付の完了および管理のためにGive Protocolがこの記録を処理することに明示的に同意します。",
    "donation.art9Consent.label": "寄付データの同意",
    "donation.art9Consent.required":
      "続行するには寄付データの処理に同意する必要があります。",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "GDPR第32条に基づく技術的措置として、個人データへの管理者アクセスを記録および監視しています。これには、実行された操作とその発生時刻が含まれ、不正アクセスの検出、説明責任の実証、および個人データ侵害（第34条）が万一発生した場合の事象の再構成を目的としています。寄付者の個人データは、これらの管理者アクセスログに複製されません。管理者アクセスログは、§7.1に記載されている認証およびセキュリティログとは異なるものであり、その保持期間は当社の内部処理活動記録によって定められています。",

    // Remaining i18n keys — batch translation
    "admin.auditTrail.filterByAction": "アクションで絞り込む",
    "admin.auditTrail.allActions": "すべてのアクション",
    "admin.auditTrail.action.charityStatusChange": "慈善団体のステータス変更",
    "admin.auditTrail.action.userStatusChange": "ユーザーのステータス変更",
    "admin.auditTrail.action.donationFlag": "寄付のフラグ付け",
    "admin.auditTrail.action.donationFlagResolve": "寄付フラグの解決",
    "admin.auditTrail.action.validationOverride": "検証のオーバーライド",
    "admin.auditTrail.action.configChange": "設定変更",
    "admin.auditTrail.action.verificationApprove": "認証承認",
    "admin.auditTrail.action.verificationReject": "認証却下",
    "admin.auditTrail.action.charitySuspend": "慈善団体の一時停止",
    "admin.auditTrail.action.charityReinstate": "慈善団体の復帰",
    "admin.auditTrail.action.userSuspend": "ユーザーの一時停止",
    "admin.auditTrail.action.userReinstate": "ユーザーの復帰",
    "admin.auditTrail.action.userBan": "ユーザーの禁止",
    "admin.auditTrail.action.viewPii": "PIIの閲覧",
    "admin.auditTrail.action.viewPiiList": "PIIリストの閲覧",
    "admin.auditTrail.viewedEntity":
      "管理者{{adminId}}が{{entityType}} {{entityId}}を閲覧しました",
    "admin.auditTrail.viewedList":
      "管理者{{adminId}}が{{entityType}}リストを閲覧しました（ページ{{page}}、フィルター：{{filters}}）",
    "admin.auditTrail.viewedListNoFilters":
      "管理者{{adminId}}が{{entityType}}リストを閲覧しました（ページ{{page}}）",
    "admin.actions.platformNews": "プラットフォームニュース",
    "admin.actions.platformNewsDesc":
      "閲覧ページに表示されるニュース項目を管理",
    "admin.news.activate": "{{title}}を公開",
    "admin.news.activated": "ニュース項目が公開されました",
    "admin.news.activeLabel": "公開中（一般に公開）",
    "admin.news.categoryLabel": "カテゴリー",
    "admin.news.contentLabel": "内容・抜粋",
    "admin.news.contentPlaceholder": "ニュース項目の簡単な説明...",
    "admin.news.createNews": "ニュース項目を作成",
    "admin.news.createNewsBtn": "ニュースを作成",
    "admin.news.created": "ニュース項目が作成されました",
    "admin.news.dateLabel": "公開日",
    "admin.news.deactivate": "{{title}}を非公開にする",
    "admin.news.deactivated": "ニュース項目が非表示になりました",
    "admin.news.deleteItem": "{{title}}を削除",
    "admin.news.deleted": "ニュース項目が削除されました",
    "admin.news.editItem": "{{title}}を編集",
    "admin.news.editNews": "ニュース項目を編集",
    "admin.news.imageLabel": "画像URL（任意）",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "非公開",
    "admin.news.newItem": "新規項目",
    "admin.news.noItemsMessage":
      "最初のニュース項目を作成して、コミュニティに最新情報を共有しましょう",
    "admin.news.noItemsYet": "ニュース項目はまだありません",
    "admin.news.publishedOn": "{{date}}に公開",
    "admin.news.saving": "保存中...",
    "admin.news.subtitle": "公開閲覧ページに表示されるニュース項目を管理します",
    "admin.news.title": "プラットフォームニュース",
    "admin.news.titleLabel": "タイトル",
    "admin.news.titlePlaceholder": "例：四半期インパクトレポート",
    "admin.news.updateNews": "ニュースを更新",
    "admin.news.updated": "ニュース項目が更新されました",
    "admin.news.urlLabel": "リンクURL",
    "admin.news.urlPlaceholder": "https://example.org/article",
    "charity.walletBadge.institutionalLabel": "{{custodianName}}に保管",
    "charity.walletBadge.institutionalTooltip":
      "寄付は、適格な機関カストディアンが保有するウォレットに送られます。",
    "charity.walletBadge.safeLabel":
      "マルチシグ財務・{{count}}人中{{threshold}}人の署名者",
    "charity.walletBadge.safeTooltip":
      "寄付は、資金移動前に複数の承認を必要とするマルチシグネチャウォレットに送られます。",
    "wallet.eoa.chain": "ネットワーク",
    "wallet.eoa.checkAuthorized":
      "私は、このウォレットを慈善寄付の受取アドレスとして指定する権限を組織から与えられています。",
    "wallet.eoa.checkRisk":
      "シングルサイナーウォレットはマルチシグよりもリスクが高く、秘密鍵を紛失すると資金を永久に失うことを理解しています。",
    "wallet.eoa.confirmSubtitle":
      "このウォレットを登録する前に、以下の内容をご確認ください。",
    "wallet.eoa.confirmTitle": "最終確認",
    "wallet.eoa.connectFirst": "まずウォレットを接続してください。",
    "wallet.eoa.connectWallet": "ウォレットを接続",
    "wallet.eoa.missingSignature":
      "署名がありません。戻ってもう一度署名してください。",
    "wallet.eoa.proceedAnyway": "理解した上で続行する",
    "wallet.eoa.register": "ウォレットを登録",
    "wallet.eoa.registering": "登録中...",
    "wallet.eoa.rejected": "署名リクエストが拒否されました。",
    "wallet.eoa.riskParagraph1":
      "シングルサイナー（EOA）ウォレットは1つの秘密鍵によって管理されます。その鍵が紛失、盗難、または漏洩した場合、このウォレットに送られた資金はすべて永久に回復不能となります。",
    "wallet.eoa.riskParagraph2":
      "組織の資金については、代わりにマルチシグSafeウォレットの使用を強くお勧めします。マルチシグウォレットはすべての取引に複数の承認を必要とし、単一障害点を防ぎます。",
    "wallet.eoa.riskParagraph3":
      "続行することにより、秘密鍵の漏洩、紛失、または管理不備による資金の損失についてGive Protocolが責任を負わないことを承諾したものとみなされます。",
    "wallet.eoa.riskTitle": "シングルサイナーウォレット：重要なリスク",
    "wallet.eoa.signError":
      "メッセージの署名に失敗しました。もう一度お試しください。",
    "wallet.eoa.signMessage": "検証メッセージに署名",
    "wallet.eoa.signSubtitle":
      "ウォレットを接続し、このアドレスを管理していることを証明するメッセージに署名してください。",
    "wallet.eoa.signTitle": "接続して署名",
    "wallet.eoa.useMultisig": "代わりにマルチシグを使用",
    "wallet.eoa.walletConnection": "ウォレット",
    "wallet.eoa.walletToRegister": "登録するウォレット",
    "wallet.institutional.address": "ウォレットアドレス",
    "wallet.institutional.attestation": "証明書類",
    "wallet.institutional.attestationHelp":
      "カストディ関係を証明するPDF、JPEG、またはPNGをアップロードしてください（最大10MB）。",
    "wallet.institutional.backToWallets": "ウォレット一覧に戻る",
    "wallet.institutional.chain": "ネットワーク",
    "wallet.institutional.chooseFile": "ファイルを選択またはドラッグ＆ドロップ",
    "wallet.institutional.custodian": "カストディアン",
    "wallet.institutional.fileTooLarge":
      "ファイルは10MB未満である必要があります。",
    "wallet.institutional.invalidAddress":
      "有効なEthereumアドレス（0x...）を入力してください",
    "wallet.institutional.invalidFileType":
      "PDF、JPEG、またはPNGファイルをアップロードしてください。",
    "wallet.institutional.removeFile": "ファイルを削除",
    "wallet.institutional.selectCustodian":
      "カストディアンを選択してください。",
    "wallet.institutional.selectCustodianOption": "カストディアンを選択...",
    "wallet.institutional.submit": "審査のために送信",
    "wallet.institutional.submittedDesc":
      "機関カストディウォレットの登録は審査中です。3営業日以内にメールが届きます。",
    "wallet.institutional.submittedTitle":
      "ウォレットが審査のために送信されました",
    "wallet.institutional.submitting": "送信中...",
    "wallet.institutional.subtitle":
      "カストディアンが管理するウォレットの詳細を入力し、確認のための証明書類をアップロードしてください。",
    "wallet.institutional.title": "機関カストディウォレットを登録",
    "wallet.institutional.uploadFile": "証明ファイルをアップロード",
    "wallet.institutional.uploadRequired":
      "証明書類をアップロードしてください。",
    "wallet.safe.address": "Safeアドレス",
    "wallet.safe.chain": "ネットワーク",
    "wallet.safe.connectFirst": "まず署名者ウォレットを接続してください。",
    "wallet.safe.connectSigner": "署名者ウォレットを接続",
    "wallet.safe.createNew": "新しいSafeを作成",
    "wallet.safe.createNewDesc":
      "app.safe.globalが開き、新しいマルチシグを作成できます。デプロイが完了したらここに戻ってください。",
    "wallet.safe.haveOne": "既にSafeを持っています",
    "wallet.safe.haveOneDesc":
      "Safeアドレスを入力し、署名者ウォレットからメッセージに署名して管理権限を確認してください。",
    "wallet.safe.invalidAddress":
      "有効なEthereumアドレス（0x...）を入力してください",
    "wallet.safe.rejected": "署名リクエストが拒否されました。",
    "wallet.safe.signError":
      "検証メッセージの署名に失敗しました。もう一度お試しください。",
    "wallet.safe.signVerify": "署名して管理権限を確認",
    "wallet.safe.signerWallet": "署名者ウォレット",
    "wallet.safe.subtitle":
      "Safeはすべての取引に複数の署名者による承認を必要とし、慈善団体の資金に最高レベルのセキュリティを提供します。",
    "wallet.safe.title": "Safeマルチシグウォレットを設定",
    "wallet.safe.verifyTitle": "Safeの所有権を確認",
    "wallet.safe.verifying": "確認中...",
    "wallet.setup.addAnother": "別のウォレットを追加",
    "wallet.setup.custodian": "カストディアン",
    "wallet.setup.deleteFailed": "ウォレットの削除に失敗しました",
    "wallet.setup.eoaDesc":
      "1つの秘密鍵で管理される標準的なウォレットです。最もシンプルですが、組織利用には最もセキュリティが低くなります。",
    "wallet.setup.eoaTitle": "シングルサイナー（EOA）",
    "wallet.setup.institutionalDesc":
      "適格なカストディアン（Fireblocks、Anchorageなど）によって管理されます。証明書類が必要です。",
    "wallet.setup.institutionalTitle": "機関カストディ",
    "wallet.setup.makePrimary": "プライマリに設定",
    "wallet.setup.primary": "プライマリ",
    "wallet.setup.primaryFailed": "プライマリウォレットの更新に失敗しました",
    "wallet.setup.primaryUpdated": "プライマリウォレットが更新されました",
    "wallet.setup.recommended": "推奨",
    "wallet.setup.remove": "ウォレットを削除",
    "wallet.setup.safeDesc":
      "すべての取引に複数の署名者が必要です。組織資金に最高のセキュリティを提供します。",
    "wallet.setup.safeSigners": "署名者",
    "wallet.setup.safeTitle": "マルチシグSafe",
    "wallet.setup.subtitle":
      "慈善団体が暗号資産の寄付を受け取る方法を選択してください。セキュリティを最大化するため、マルチシグウォレットを推奨します。",
    "wallet.setup.title": "受取ウォレットを設定",
    "wallet.setup.viewExplorer": "ブロックエクスプローラーで表示",
    "wallet.setup.walletAdded": "ウォレットが正常に登録されました",
    "wallet.setup.walletDeleted": "ウォレットが削除されました",
    "wallet.setup.walletsTitle": "受取ウォレット",
    "admin.nav.dashboard": "ダッシュボード",
    "admin.nav.reports": "レポートと分析",
    "admin.nav.charities": "慈善団体",
    "admin.nav.donations": "寄付",
    "admin.nav.impactMetrics": "インパクト指標",
    "admin.nav.portfolioFunds": "ポートフォリオファンド",
    "admin.nav.contentModeration": "コンテンツモデレーション",
    "admin.nav.settings": "システム設定",
    "admin.nav.overview": "概要",
    "admin.nav.operations": "運用",
    "admin.nav.consoleLabel": "管理コンソール",
    "admin.shell.searchPlaceholder":
      "寄付者、慈善団体、トランザクションハッシュを検索…",
    "admin.shell.searchLabel": "管理コンソールを検索",
    "admin.shell.notifications": "通知",
    "admin.shell.adminLabel": "管理者",
    "admin.shell.superAdmin": "スーパー管理者",
    "admin.shell.signOut": "サインアウト",
    "admin.shell.backToPublicSite": "公開サイトに戻る",
    "admin.shell.homeLink": "Give Protocolホーム",
    "admin.dashboard.severityHigh": "優先度：高",
    "admin.dashboard.severityMedium": "対応が必要",
    "admin.dashboard.severityLow": "要確認",
    "admin.dashboard.alertOldest": "最も古いリクエストの提出日",
    "admin.dashboard.alertReviewHint": "オンボーディングを進めるためのレビュー",
    "admin.dashboard.reviewQueue": "レビューキュー",
    "admin.dashboard.kpiDonorsSub": "過去30日間で新規{{count}}件",
    "admin.dashboard.kpiPending": "{{count}}件が保留中",
    "admin.dashboard.awaitingVerification": "認証待ち",
    "admin.dashboard.kpiVerifiedSub": "承認済み合計{{total}}件中",
    "admin.dashboard.kpiVolunteersActive": "アクティブな申し込み",
    "admin.dashboard.kpiVolunteersSub": "アクティブな申し込みはありません",
    "admin.dashboard.donationVolume": "寄付額",
    "admin.dashboard.donationVolumeSub": "{{range}}・暗号資産と法定通貨の合計",
    "admin.dashboard.range30d": "過去30日間",
    "admin.dashboard.range90d": "過去90日間",
    "admin.dashboard.rangeYtd": "年初来",
    "admin.dashboard.volumeEmptyTitle": "まだ寄付が記録されていません",
    "admin.dashboard.volumeEmptySub":
      "最初の寄付が確定すると、ここに額が表示されます",
    "admin.dashboard.totalVolume": "合計額",
    "admin.dashboard.crypto": "暗号資産",
    "admin.dashboard.fiat": "法定通貨",
    "admin.dashboard.activitySubtitle":
      "リアルタイムのプラットフォームイベント",
    "admin.dashboard.viewAllActivity": "すべてのアクティビティを表示",
    "admin.dashboard.viewAllDonations": "すべての寄付を表示",
    "admin.charity.tabAll": "すべて",
    "admin.charity.review": "審査",
    "admin.charity.colOrganization": "組織",
    "admin.charity.colRaised": "調達額",
    "admin.charity.colSubmitted": "提出日",
    "admin.charity.searchAria": "慈善団体を検索",
    "admin.charity.reviewTitle": "{{name}}を審査",
    "admin.charity.submittedRelative": "{{when}}に提出",
    "admin.charity.contactEmail": "メール",
    "admin.charity.contactPhone": "電話",
    "admin.charity.raisedUnavailable": "調達額の合計は利用できません",
    "admin.error.title": "データ読み込みエラー",
    "admin.error.recentActivity": "最近のアクティビティの読み込みエラー",
    "admin.error.alerts": "アラートの読み込みエラー",
    "admin.error.donationVolume": "寄付額の読み込みエラー",
    "donation.gas.estimating": "ネットワーク手数料を見積もっています…",
    "donation.gas.label": "推定ネットワーク手数料",
    "donation.gas.highGasWarning":
      "高額ガス警告：推定手数料は{{usd}}で、寄付額の{{pct}}に相当します。",
    "donation.gas.highGasSuggestion":
      "より大きな寄付額にするか、手数料の低いチェーンへの切り替えをご検討ください。",
    "donation.gas.l2Hint": "手数料を抑えるには、{{chains}}をお試しください。",
  },
};
